import { registerQuery } from 'data-fetching-client';
import { profilesAppClient } from 'marketplace-ui-common/clients/profilesClient';
export const GET_USER_INSIGHTS = registerQuery({
  fieldName: 'userInsights',
  fetcher: () => profilesAppClient.get(`/user-insights`)
});